<div class="date-picker" [class]="field.classname?field.classname:''" >
  <input [class.disabled]="field.disabled" [placeholder]="setPlaceHolder()" [formControl]="dateControl"
    [class]="field.inputClassName?field.inputClassName:''" [readOnly]="field.disabled?true:false" 
    (click)="field.disabled? null:inputClick()" #input [id]="parentId" autocomplete="off"
    [class.is-invalid]="isInValid " appPreventFirstSpace>
  <div style="display: none;">
    <div class="datepicker-overlay" tabindex="0" #datepicker>
      <div class="datepicker" *ngIf="toggle" id="datepicker-v2">
        <div class="datepicker-header">
          <img src="assets/images/icons/calendar-icon.svg" alt="calendar icon">
          <div>
            <div class="datepicker-title">
              <span class="datepicker-title-text">Select date</span>
            </div>
            <div class="datepicker-date" [class]="field.datepickerHeaderClass?field.datepickerHeaderClass:''">
              <ng-container *ngIf="!field.range">
                <span class="datepicker-date-text" *ngIf="!field.timer">
                  {{activeDate?.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit' })}}
                </span>
                <div *ngIf="field.timer">
                  <span class="datepicker-date-time-text">
                    {{setActiveDateWithTime()}}
                  </span>
                  <span (click)="toggleTimer()" style="float: right;padding-top: 5px;"> &nbsp;
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
                      <path
                        d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 6 L 11 12.414062 L 15.292969 16.707031 L 16.707031 15.292969 L 13 11.585938 L 13 6 L 11 6 z" />
                    </svg>
                  </span>
                </div>
  
              </ng-container>
              <span class="datepicker-date-text-range" *ngIf="field.range">{{setShowRange()}}</span>
            </div>
          </div>
          
        </div>
        <div class="month" *ngIf="!showallyear">
          <div class="arrows prev-mth" [class]="field.arrowClassName?field.arrowClassName:''" (click)="prevMonth()">
            </div>
          <div class="mth" [class]="field.monthClassName">
            <button type="button" (click)="monthSelected($event)" [class]="field.headerButtonClass?field.headerButtonClass:''">{{ months[month] }}</button>
           
            <button type="button" (click)="selectYear($event)" [class]="field.headerButtonClass?field.headerButtonClass:''">{{ year }}</button>
          </div>
          <div class="arrows next-mth" [class]="field.arrowClassName?field.arrowClassName:''" (click)="nextMonth()"></div>
        </div>
        <div class="datepicker-footer">
          <button class="datepicker-footer-btn datepicker-clear-btn" (click)="clickClear()">Clear</button>
          <button class="datepicker-footer-btn " (click)="clickCancle($event)">Cancel</button>
          <button class="datepicker-footer-btn " [disabled]="selectRangeCheck()" [ngClass]="{'disabled': selectRangeCheck()}" (click)="ClickOk($event)">Ok</button>

        </div>
        <div class="days" *ngIf="showdays">
          <div class="day" *ngFor="let dayName of weekdays" [class]="field.dayClassName?field.dayClassName:''">{{dayName}}</div>
          <ng-container *ngFor="let week of days">
            <ng-container *ngFor="let day of week">
              <div class="day" (click)="selectDay(day)" [ngClass]="getClass(day)">{{day.day}}</div>
            </ng-container>
          </ng-container>
        </div>
        <div class="showallmonth" *ngIf="showallmonth" #showallmonth>
          <div class="mon">
            <div *ngFor="let m of months; let i=index;" class="mthlist" (click)="changeMonth(i)"
              [ngClass]="getMonthClass(i)" [class]="field.monthClassName?field.monthClassName:''">{{m}}</div>
          </div>
        </div>
        <div *ngIf="showallyear">
          <div class="yearhead">
            <div class="arrows prev-mth" [class]="field.arrowClassName?field.arrowClassName:''" (click)="prevYear()">
            </div> <button [class.yearshow]="true" [class]="field.headerButtonClass?field.headerButtonClass:''"  (click)="selectYear($event)">{{ year }}</button>
            <div class="arrows next-mth" [class]="field.arrowClassName?field.arrowClassName:''" (click)="nextYear()"></div>
          </div>
          <div class="year">
            <div *ngFor="let y of arrayYear; let i=index;" class="yearlist" (click)="changeYear(y)"
              [ngClass]="getYearClass(y)" [class]="field.yearClassName?field.yearClassName:''">{{y}}</div>
          </div>
        </div>

        <ng-container *ngIf="showTimer">
          <div class="time-picker">
            <select class="time-picker__select hour" id="Hour" (change)="HourChange($event)">
              <option class="options" *ngFor="let i of hourSet" [value]="i" [selected]="+i == +hour">
                {{i}}
              </option>
            </select>
            <span class="time-divider">:</span>
            <select class="time-picker__select minute" id="min" (change)="minChange($event)">
              <option class="options" *ngFor="let i of minuteArr " [value]="i" [selected]="+i == +minute">
                {{i}}
              </option>
            </select>
            <select class="time-picker__select m-0 zone" id="zone" *ngIf="field.hourFormat!=24"
              (change)="meridiemChange($event)">
              <option class="options" value="AM" [selected]="meridiem=='AM'">AM</option>
              <option class="options" value="PM" [selected]="meridiem=='PM'">PM</option>
            </select>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
